export enum MeetingActions {
  fetchMeetingHeader = '[Calendar]: fetch meeting header',
  fetchMeetingHeaderSuccess = '[Calendar]: fetch meeting header success',
  fetchMeetingHeaderFailure = '[Calendar]: fetch meeting header failure',

  updateMeetingHeader = '[Calendar]: update meeting header',
  updateMeetingHeaderSuccess = '[Calendar]: update meeting header success',
  updateMeetingHeaderFailure = '[Calendar]: update meeting header failure',

  fetchMeetingContent = '[Calendar]: fetch meeting content',
  fetchMeetingContentSuccess = '[Calendar]: fetch meeting content success',
  fetchMeetingContentFailure = '[Calendar]: fetch meeting content failure',

  fetchMeetingSidebar = '[Calendar]: fetch meeting sidebar',
  fetchMeetingSidebarSuccess = '[Calendar]: fetch meeting sidebar success',
  fetchMeetingSidebarFailure = '[Calendar]: fetch meeting sidebar failure',

  fetchMeetingPrimaryActions = '[Calendar]: fetch meeting primary actions',
  fetchMeetingPrimaryActionsSuccess = '[Calendar]: fetch meeting primary actions success',
  fetchMeetingPrimaryActionsFailure = '[Calendar]: fetch meeting primary actions failure',

  fetchMeetingOptionsMenuActions = '[Calendar]: fetch meeting options menu actions',
  fetchMeetingOptionsMenuActionsSuccess = '[Calendar]: fetch meeting  options menu actions success',
  fetchMeetingOptionsMenuActionsFailure = '[Calendar]: fetch meeting  options menu actions failure',

  updateMeetingAdditionalInfo = '[Calendar]: update meeting additional info',
  updateMeetingAdditionalInfoSuccess = '[Calendar]: update meeting additional info success',
  updateMeetingAdditionalInfoFailure = '[Calendar]: update meeting additional info failure',

  addMeetingAttachment = '[Calendar]: add meeting attachment',

  removeMeetingAttachment = '[Calendar]: remove meeting attachment',
  removeMeetingAttachmentSuccess = '[Calendar]: remove meeting attachment success',
  removeMeetingAttachmentFailure = '[Calendar]: remove meeting attachment failure',

  fetchMoveMeetingItemOrgans = '[Calendar]: fetch possible organs for moving a meeting item',
  fetchMoveMeetingItemOrgansSuccess = '[Calendar]: fetch possible organs for moving a meeting item success',
  fetchMoveMeetingItemOrgansFailure = '[Calendar]: fetch possible organs for moving a meeting item failure',

  fetchMoveMeetingItemDates = '[Calendar]: fetch possible dates for moving a meeting item',
  fetchMoveMeetingItemDatesSuccess = '[Calendar]: fetch possible dates for moving a meeting item success',
  fetchMoveMeetingItemDatesFailure = '[Calendar]: fetch possible dates for moving a meeting item failure',

  fetchAgendaDecisionStatusOptions = '[Calendar]: fetch agenda decision status options',
  fetchAgendaDecisionStatusOptionsSuccess = '[Calendar]: fetch agenda decision status options success',
  fetchAgendaDecisionStatusOptionsFailure = '[Calendar]: fetch agenda decision status options failure'
}

export enum MeetingVotingLetterTypes {
  'YESNO' = 'YESNO',
  'CANDIDATES' = 'CANDIDATES'
}

export enum MeetingVotingLetterVisibility {
  'PUBLIC' = 'PUBLIC',
  'PRIVATE' = 'PRIVATE'
}
